import { InputNode } from '@modules/campaigns/Domain/Interfaces/InputNodeTransform';
import { OutputNode } from '@modules/campaigns/Domain/Interfaces/OutputNodeTransform';
import { nodeTypeMap } from '@modules/campaigns/Domain/Factories/typeNodeConverter';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { RetryTimeRange } from '@modules/campaigns/Domain/Interfaces/INodeConfig';

export function transformNodes(inputNodes: InputNode[]): OutputNode[] {
  //TODO: Each node in class hosuld transofrm method
  return inputNodes.map((inputNode) => {
    const nodeType = inputNode.type as NodeType;

    if (!(nodeType in nodeTypeMap)) {
      throw new Error(`Invalid node type: ${inputNode.type}`);
    }

    let parameters: any = { ...inputNode.config, name: inputNode.type };

    if (nodeType === NodeType.MakeOutBoundCall) {
      const transformed = transformNodeForApi({
        nodeId: inputNode.id,
        type: nodeTypeMap[nodeType],
        parameters,
      });
      parameters = transformed.parameters;
    }

    if (nodeType === NodeType.WaitDaysForDueDate) {
      const antesODespues = parameters['antesODespues'];
      const waitDays = parameters['waitDays'];

      // CONVERT ANTES O DESPUES NEGATIVE NUMBER OF WAITDAYS
      if (antesODespues === 'beforeDueDate' && waitDays > 0) {
        parameters['waitDays'] = -waitDays;
      } else if (antesODespues === 'afterDueDate' && waitDays < 0) {
        parameters['waitDays'] = -1 * waitDays;
      }
    }

    if (parameters['sendToAllContacts'] === '') {
      parameters['sendToAllContacts'] = false;
    }

    if (
      parameters['percentage'] !== undefined &&
      parameters['percentage'] !== null &&
      parameters['percentage'] !== ''
    ) {
      parameters['percentage'] = Number(parameters['percentage']);
    }

    return {
      nodeId: inputNode.id,
      type: nodeTypeMap[nodeType],
      parameters: parameters,
      diagram: {
        coordinates: {
          x: Math.round(inputNode.position.x),
          y: Math.round(inputNode.position.y),
        },
      },
      childrenIds: inputNode.childrenNodes,
    };
  });
}

export function transformNodeForApi(node: any): any {
  const { nodeId, type, parameters } = node;

  const transformed: any = {
    nodeId,
    type,
    parameters: {
      name: parameters.name,
      copyId: parameters.copyId || '',
      agentId: parameters.agentId,
      voiceId: parameters.voiceId || '',
      callToAllContacts: parameters.isContactAll === 'true' || parameters.isContactAll === true,
      callIntervals: [],
      actions: [],
      customFieldsMapping: parameters.customFieldsMapping || [],
    },
  };

  if (Array.isArray(parameters.retryTimeRanges) && node.parameters.isRetryFailCalls) {
    transformed.parameters.callIntervals = parameters.retryTimeRanges
      .filter((range: RetryTimeRange) => range.selected)
      .map((range: RetryTimeRange) => ({
        start: range.from,
        finish: range.to,
      }));
  }

  if (Array.isArray(parameters.actions)) {
    transformed.parameters.actions = parameters.actions.map((action: any) => {
      const transformedAction: any = {
        conversationResult: action.situation,
        action: action.action === 'endFeedback' ? 'feedback' : action.action,
        parameters: {},
      };

      if (action.action === 'assignCampaign' && action.campaign) {
        transformedAction.parameters.workflowId = action.campaign;
      }

      return transformedAction;
    });
  }
  return transformed;
}

export function transformOutboundCallConfigFromApi(parameters: any): any {
  const {
    name,
    callToAllContacts,
    callIntervals = [],
    actions = [],
    agentId,
    isRetryFailCalls,
  } = parameters;

  const defaultRanges: RetryTimeRange[] = [
    {
      label: 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.RETRY',
      from: '08:00',
      to: '12:00',
      selected: false,
    },
    {
      label: 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.RETRY',
      from: '13:00',
      to: '16:00',
      selected: false,
    },
    {
      label: 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.RETRY',
      from: '17:00',
      to: '20:00',
      selected: false,
    },
  ];

  const retryTimeRanges = defaultRanges.map((defaultRange, index) => {
    const interval = callIntervals[index];
    if (interval) {
      return {
        ...defaultRange,
        from: interval.start,
        to: interval.finish,
        selected: true,
      };
    }
    return defaultRange;
  });

  const transformedActions = actions.map((action: any) => {
    return {
      situation: action.conversationResult,
      action: action.action === 'feedback' ? 'endFeedback' : action.action,
      campaign: action.parameters?.workflowId || undefined,
    };
  });

  return {
    name,
    agentId,
    isContactAll: callToAllContacts,
    isRetryFailCalls:
      typeof isRetryFailCalls === 'boolean' ? isRetryFailCalls : callIntervals.length > 0,
    retryTimeRanges,
    actions: transformedActions,
  };
}
